"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var react_html_parser_1 = require("react-html-parser");
var portal_core_1 = require("@ferry/portal-core");
var InfoBannerWidget = /** @class */ (function (_super) {
    __extends(InfoBannerWidget, _super);
    function InfoBannerWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoBannerWidget.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: this.parseBannerWording() });
    };
    InfoBannerWidget.prototype.parseBannerWording = function () {
        var wording = this.getSetting("wording", "");
        return (0, react_html_parser_1.default)(this.renderTemplate(wording, true), { transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            } });
    };
    InfoBannerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "wording", type: journey_model_1.TypeDescriptions.Html }
        ])
    ], InfoBannerWidget);
    return InfoBannerWidget;
}(plugin_journey_1.OutputWidgetBase));
exports.InfoBannerWidget = InfoBannerWidget;
//# sourceMappingURL=InfoBannerWidget.js.map